<template>
  <form-select
      v-model="selectedIds"
      :p-currencies="pCurrencies"
      :p-language="pLanguage"
      :p-dictionary="pDictionary"
      :p-urls="pUrls"
      :p-error-list="pErrorList"
      :p-src="pSrc"
      :p-src-id="pSrcId"
      :p-error-key="pErrorKey"
      :p-required="pRequired"
      p-select-id-prefix="organization"
      :p-input-name="pInputName"
      :p-select-container="pSelectContainer"
      :p-disabled="pDisabled"
      :p-ref-list="organizationRefList"
      :p-multiple="pMultiple"
      :p-dictionary-key-label="dictionaryKeyLabel"
      p-dictionary-key-count="dictionary.organization.count"
      :p-dictionary-key-select="dictionaryKeySelect">
  </form-select>
</template>

<script>
import FormSelect from "@/components/ui/FormSelect";

export default {
  name: "OrganizationSelectMultiple",
  components: {FormSelect},
  props: {
    value: [Number, Array],
    pCurrencies: Array,
    pLanguage: String,
    pDictionary: Object,
    pUrls: Object,
    pErrorList: {
      type: Object,
      default: function () {
        return {}
      }
    },
    pSrc: String,
    pSrcId: String,
    pErrorKey: String,
    pRequired: Boolean,
    pInputName: String,
    pSelectContainer: {
      default: function () {
        return ""
      }
    },
     pMultiple: {
        type: Boolean,
        default: function () {
           return false;
        }
     },
    pDisabled: Boolean,
     pDataListUrl: {
        type: String,
        default: function() {
           return '/mediaplan/app/endpoints/json-api/ref/organizations';
        }
     },
    pDataListInput: {
      type: Object,
      default: function () {
        return {
          output: 1 /* group by organization group */
        }
      }
    },
     pDictionaryKeySelect: String
  },
  data: function () {
    return {
      organizationRefList: [],
      selectedIds: this.value
    }
  },
  methods: {
    refreshOrganizationList: function (dataListInput) {
      let _component = this;
      $.ajax({
               type: "POST",
               url: _component.pDataListUrl,
               data: JSON.stringify(dataListInput),
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (refList) {
        _component.organizationRefList = refList;
      });
    }
  },
  computed: {
     dictionaryKeyLabel: function() {
        return this.pMultiple ? "dictionary.organization.plural" : "dictionary.organization";
    },
     dictionaryKeySelect: function() {
        if(this.pDictionaryKeySelect) return this.pDictionaryKeySelect;
        return this.pMultiple ? "dictionary.organization.select.multiple" : "dictionary.organization.select.single";
    }
  },
  watch: {
    value: function (newValue) {
      this.selectedId = newValue;
    },
    selectedIds: function () {
      this.$emit('input', this.selectedIds)
    },
    pDataListInput: function (newDataListInput) {
      this.refreshOrganizationList(newDataListInput);
    }
  },
  mounted: function () {
    this.refreshOrganizationList(this.pDataListInput);
  }
}
</script>

<style scoped>

</style>